const state = {
  configurationFilters: {},
  achievmentClubbingData: {},
  proDataSetupData: {},
  branchDropdownOptions:[],
  jobLists: [],
  groupTypeLists: [],
  ShipToCodeForCcnPrefData: [],
};

export default state;
